import * as React from "react";

export interface ThenProps {
    visible: boolean;
    children: React.ReactNode;
}

export function Then(props: ThenProps): JSX.Element {
    if (!props.visible) {
        return <></>;
    }
    return <>{props.children}</>;
}

export interface ElseProps {
    visible: boolean;
    children: React.ReactNode;
}

export function Else(props: ElseProps): JSX.Element {
    if (!props.visible) {
        return <></>;
    }
    return <>{props.children}</>;
}

export interface IfProps {
    children: Array<React.ReactElement<ThenProps, typeof Then> | React.ReactElement<ElseProps, typeof Else>>;
}

export function If(props: IfProps): null | JSX.Element {
    return <>{props.children}</>;
}
